module.exports = __webpack_public_path__ + "static/media/normal-theme-mode-icon.55dc580d.svg";